import { render, staticRenderFns } from "./MegaMenuExpandColumn.vue?vue&type=template&id=3ecdf071&"
import script from "./MegaMenuExpandColumn.vue?vue&type=script&lang=js&"
export * from "./MegaMenuExpandColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports